import html2canvasWithSettings from './html2canvasWithSettings';

export default async function downloadElementPdf(element, filename) {
  const canvas = await html2canvasWithSettings(element);
  const { default : JSPDF } = await import('jspdf');
  const pdf = new JSPDF('p', 'mm', 'a4');
  pdf.addImage(canvas.toDataURL('image/jpeg'), 'jpeg', 16, 16, 178, 180);
  pdf.save(filename);
}
